<backstage-spinner
  [spinning]="spinning"
  position="fixed"/>
<div class="container mb-5">
  <app-search-params-container
    #paramsContainer
    [params]="params"
    (paramsChange)="paramsChange.emit($event)">
    <backstage-layout-grid [gap]="3">
      <backstage-layout-grid-cell
        [span]="{xs: 12, lg: 9}"
        [start]="{xs: 1, lg: 4}">
        <app-search-filter-query
          (instantSearchResultClicked)="handleInstantSearchResultClicked($event)"/>
        <app-did-you-mean
          [suggestions]="search.data.suggestions"
          class="d-block ms-3"/>
      </backstage-layout-grid-cell>
      <backstage-layout-grid-cell
        [span]="{xs: 12, lg: 3}"
        class="pe-lg-3">
        <div class="mb-sm-4">
          <div class="mb-3 text-center text-sm-start">
            <backstage-button variant="outline-primary" (clicked)="paramsContainer.resetParams()">Reset
            </backstage-button>
            <backstage-button class="d-sm-none ms-2" variant="primary" (clicked)="filters.toggle()"><span
              class="material-symbols-outlined">filter_list</span> {{ filters.show ? 'Hide' : 'Show' }} filters
            </backstage-button>
          </div>
          <div>
            <app-search-filter-chips/>
          </div>
        </div>
        <app-layout-hidden-on-mobile #filters>
          <h3 class="mb-4">Filters</h3>
          <backstage-layout-foldable-section
            #sourceSection
            [collapsed]="tab?.id === 'all'"
            headingText="Source">
            <app-search-filter-source
              (visible)="sourceSection.visible = $event"
              [aggregation]="search.aggregations?.source"/>
          </backstage-layout-foldable-section>
          <backstage-layout-foldable-section
            #tagsSection
            headingText="Tag">
            <app-search-filter-value-list
              filterName="tags"
              (visible)="tagsSection.visible = $event"
              [keyValues]="search.aggregations?.tags | aggregationKeyValue"/>
          </backstage-layout-foldable-section>
          <backstage-layout-foldable-section
            #productSection
            headingText="Product">
            <app-search-filter-product
              (visible)="productSection.visible = $event"/>
          </backstage-layout-foldable-section>
          <backstage-layout-foldable-section
            #publicationTypeSection
            headingText="Category">
            <app-search-filter-value-list
              filterName="publicationType"
              (visible)="publicationTypeSection.visible = $event"
              [keyValues]="search.aggregations?.publicationType | aggregationKeyValue"/>
          </backstage-layout-foldable-section>
          <backstage-layout-foldable-section
            #entityTypeSection
            headingText="Type">
            <app-search-filter-entity-type
              (visible)="entityTypeSection.visible = $event"
              [aggregation]="search.aggregations?.entityType"/>
          </backstage-layout-foldable-section>
          <backstage-layout-foldable-section
            #librarySection
            [collapsed]="true"
            headingText="Library">
            <app-search-filter-library
              (visible)="librarySection.visible = $event"
              [aggregation]="search.aggregations?.library"/>
          </backstage-layout-foldable-section>
          <backstage-layout-foldable-section
            #prioritySection
            [collapsed]="true"
            headingText="Priority">
            <app-search-filter-value-list
              filterName="priority"
              (visible)="prioritySection.visible = $event"
              [keyValues]="search.aggregations?.priority | aggregationKeyValue"/>
          </backstage-layout-foldable-section>
          <backstage-layout-foldable-section
            #statusSection
            [collapsed]="true"
            headingText="Status">
            <app-search-filter-value-list
              filterName="status"
              (visible)="statusSection.visible = $event"
              [keyValues]="search.aggregations?.status | aggregationKeyValue"/>
          </backstage-layout-foldable-section>
          <backstage-layout-foldable-section
            #projectSection
            [collapsed]="true"
            headingText="Project">
            <app-search-filter-value-list
              filterName="project"
              (visible)="projectSection.visible = $event"
              [keyValues]="search.aggregations?.project | aggregationKeyValue"/>
          </backstage-layout-foldable-section>
        </app-layout-hidden-on-mobile>
      </backstage-layout-grid-cell>
      <backstage-layout-grid-cell [span]="{xs: 12, lg: 9}">
        <app-layout-tab-container [currentTab]="tab">
          @for (tab of tabList; track tab) {
            <app-layout-tab
              [tab]="tab"/>
          }
          @if (tab !== tabLookup.all) {
            <div
              class="d-flex">
              <app-search-params-sort class="ms-auto mt-3"/>
            </div>
          }
          <app-search-hit-count
            [tab]="tab"
            [total]="search.data.total"
            [searchHasRun]="search.hasRun"/>
          <app-tab/>
        </app-layout-tab-container>
      </backstage-layout-grid-cell>
    </backstage-layout-grid>
  </app-search-params-container>
</div>
